require.register("modules/m04/m04-activity/page-4-il/page-4-il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_4il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_4il;

  
});

